<mat-drawer-container (backdropClick)="sidebarToggle()" [hasBackdrop]="toggle">
  <mat-drawer-content>
    <div class="box-wrapper">
      <header>
        <div class="menu-home">
          <button class="openbtn" (click)="sidebarToggle()">
            <app-icon>menu</app-icon>
          </button>
        </div>
        <div class="icon" (click)="goBack()">
          <img class="logo-crm" src="/assets/images/logos/logo-crm-jestos.png" alt="logo-icon" />
        </div>
        <h2 class="center-of-clients">Центр підтримки клієнтів</h2>
      </header>
      <div id="private" class="wrapper">
        <h3>{{ 'private_policy' | translate }}</h3>
        @for (section of policySections; track section) {
          <section>
            <h5>{{ section.title }}</h5>
            <p>{{ section.text }}</p>
          </section>
        }
      </div>
      <div id="cookie" class="wrapper">
        <h3>{{ 'policy_file_cookie' | translate }}</h3>
        @for (section of policySections; track section) {
          <section>
            <h5>{{ section.title }}</h5>
            <p>{{ section.text }}</p>
          </section>
        }
      </div>
      <div id="term" class="wrapper">
        <h3>Умови використання</h3>
        @for (section of policySections; track section) {
          <section>
            <h5>{{ section.title }}</h5>
            <p>{{ section.text }}</p>
          </section>
        }
      </div>
      <div class="links">
        <p class="">
          <a class="anchor-link text-white" href="/policy#private">{{ 'private_policy' | translate }}</a>
        </p>
        <p class="">
          <a class="anchor-link text-white" href="/policy#cookie">{{ 'policy_file_cookie' | translate }}</a>
        </p>
        <p class="">
          <a class="anchor-link text-white" href="/policy#term">Умови використання</a>
        </p>
      </div>
    </div>
  </mat-drawer-content>
  <mat-drawer position="end" mode="over" [opened]="toggle">
    <div #mySidebar class="sidebar">
      <a href="javascript:void(0)" class="closebtn" (click)="sidebarToggle()">×</a>
      <p class="">
        <a class="anchor-link text-white" href="/policy#private">{{ 'private_policy' | translate }}</a>
      </p>
      <p class="">
        <a class="anchor-link text-white" href="/policy#cookie">{{ 'policy_file_cookie' | translate }}</a>
      </p>
      <p class="">
        <a class="anchor-link text-white" href="/policy#term">Умови використання</a>
      </p>
    </div>
  </mat-drawer>
</mat-drawer-container>
